import type { LiveHelpRequestWithNullableSessionDetails } from '@/components/Worlds/types'

/**
 * Note: this logic should match the logic in LiveHelpRequestQ.getActiveLiveHelpRequests query
 */
export default function isLiveHelpRequestActive(
  liveHelpRequest: LiveHelpRequestWithNullableSessionDetails
): boolean {
  return liveHelpRequest.canceledAt == null && liveHelpRequest.completedAt == null
}
